import "./DealershipsPage.css"
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchDealerships } from "../../redux/actions/dealership.actions";
import DealershipsContainer from "./components/DealershipsContainer";
import { fetchCountries } from "../../redux/actions/countries.actions";
import { fetchUserData } from "../../redux/actions/user.actions";
import DeleteDealershipModal from "./components/DeleteDealershipModal";
import AddDealershipModal from "./components/AddDealershipModal";
import UpdateDealershipModal from "./components/UpdateDealershipModal";

const DealershipsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const [addOpen, setAddOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [dealershipToModify, setDealershipToModify] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchDealerships(searchParams.toString()));
    dispatch(fetchCountries());
    dispatch(fetchUserData());
  }, [dispatch,searchParams]);

  return (
    <div className="page lp-page">
    <AddDealershipModal open={addOpen} setOpen={setAddOpen} />
    <DeleteDealershipModal open={deleteOpen} setOpen={setDeleteOpen} object={dealershipToModify} />
    <UpdateDealershipModal open={editOpen} setOpen={setEditOpen} object={dealershipToModify} />
    <Header header="Dealerships"/>
    <main className="lp-main">
      <DealershipsContainer setDeleteOpen={setDeleteOpen} setEditOpen={setEditOpen} setAddOpen={setAddOpen} setDealershipToModify={setDealershipToModify}/>
    </main>
    </div>
  );
};

export default DealershipsPage;
